module.exports = __webpack_public_path__ + "static/media/hero-3.e55f9d78.jpg";